import { registerIconLibrary } from '@shoelace-style/shoelace';

// Register FontAwesome Pro libraries using the working pattern
registerIconLibrary('fa-solid', {
    resolver: (name) => {
        const filename = name.replace(/^fa-/, '');
        const folder = 'fas';
        return `/svgs/${folder}/${filename}.svg`;
    },
    mutator: (svg) => svg.setAttribute('fill', 'currentColor'),
});

registerIconLibrary('fa-regular', {
    resolver: (name) => {
        const filename = name.replace(/^fa-/, '');
        const folder = 'far';
        return `/svgs/${folder}/${filename}.svg`;
    },
    mutator: (svg) => svg.setAttribute('fill', 'currentColor'),
});

registerIconLibrary('fa-light', {
    resolver: (name) => {
        const filename = name.replace(/^fa-/, '');
        const folder = 'fal';
        return `/svgs/${folder}/${filename}.svg`;
    },
    mutator: (svg) => svg.setAttribute('fill', 'currentColor'),
});

registerIconLibrary('fa-brands', {
    resolver: (name) => {
        const filename = name.replace(/^fa-/, '');
        const folder = 'fab';
        return `/svgs/${folder}/${filename}.svg`;
    },
    mutator: (svg) => svg.setAttribute('fill', 'currentColor'),
});

console.log('Font Awesome Pro icon libraries registered successfully');